import { CSSProperties, useState, useMemo, useEffect } from "react";
import classes from "./CWForm.module.css";
import { CustomFormProps } from ".";
import { useDispatch } from "react-redux";
import { CWImageType } from "../../types/widget";
import SettingFormItems, {
  SettingItem,
  SettingItems,
} from "../SettingFormItems";

export const objectKeys = Object.keys as <T>(o: T) => (keyof T)[];

const placeholderImg = "/img/image-placeholder.jpg";

type Panel = "main" | "settings";
const panels: {
  name: Panel;
  title: string;
}[] = [
  {
    name: "main",
    title: "Main",
  },
  // {
  //   name: "settings",
  //   title: "Settings",
  // },
];

type SettingNames =
  | "topSeoBgColor"
  | "topSeoTextColor"
  | "midSeoBgColor"
  | "midSeoTextColor"
  | "bottomSeoBgColor"
  | "bottomSeoTextColor";

const settingItems: SettingItem<SettingNames>[] = [
  {
    key: "topSeoBgColor",
    name: "Top SEO Background Color",
    type: "color",
  },
  {
    key: "topSeoTextColor",
    name: "Top SEO Text Color",
    type: "color",
  },
  {
    key: "midSeoBgColor",
    name: "Middle SEO Background Color",
    type: "color",
  },
  {
    key: "midSeoTextColor",
    name: "Middle SEO Text Color",
    type: "color",
  },
  {
    key: "bottomSeoBgColor",
    name: "Bottom SEO Background Color",
    type: "color",
  },
  {
    key: "bottomSeoTextColor",
    name: "Bottom SEO Text Color",
    type: "color",
  },
];

type LinkKeys =
  | "phone"
  | "email"
  | "facebook"
  | "instagram"
  | "twitter"
  | "website"
  | "gitHub"
  | "linkedin"
  | "youTube"
  | "address"
  | "title";

type ContentKeys = "top" | "mid" | "bottom";

type LinkItems = {
  [key in LinkKeys]?: string;
};

const socialInputs: {
  name: string;
  placeholder: string;
  key: LinkKeys;
}[] = [
  {
    name: "title",
    placeholder: "All Campaign",
    key: "title",
  },
];

const CampaignPageTitleForm = ({
  formItems,
  customForm = false,
  name = "",
  onSubmit = () => {},
  title,
  className,
  style,
}: CustomFormProps) => {
  const [links, setLinks] = useState<LinkItems>(formItems as any);
  const [image, setImage] = useState<CWImageType>(
    (formItems as any)?.methods || ({} as any)
  );
  const [contents, setContents] = useState<{ [key in ContentKeys]?: any }>(
    (formItems as any)?.contents || ({} as any)
  );

  const [paymentMethodsActive, setPaymentMethodsActive] = useState(
    !!(formItems as any)?.methods
  );
  const [contentsActive, setContentsActive] = useState<{
    [key in ContentKeys]?: boolean;
  }>({
    top: !!(formItems as any)?.contents?.top,
    mid: !!(formItems as any)?.contents?.mid,
    bottom: !!(formItems as any)?.contents?.bottom,
  });

  const [panel, setPanel] = useState<Panel>("main");

  const classNames = [classes.CWForm, className];

  const handleSubmit = () => {
    const data: any = {
      ...links,
      methods: paymentMethodsActive ? image : undefined,
      contents: {
        ...contents,
      },
    };

    onSubmit(data as any);
  };

  return (
    <div className={classNames.join(" ")} style={style}>
      <form
        className="mainSliderForm__container"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <h1 className="title capitalize">{title}</h1>

        {/* panels switch */}
        <div className="flex flex-col md:flex-row border border-black/5 border-b-none mt-0">
          {panels.map((p) => (
            <button
              key={p.name}
              type="button"
              className={`flex-1 py-2 text-sm font-light tracking-wide text-center border-b-2 focus:outline-none ${
                panel === p.name
                  ? "border-green-500 text-black"
                  : "text-black/50 hover:text-black/70"
              }`}
              onClick={() => setPanel(p.name)}
            >
              {p.title}
            </button>
          ))}
        </div>

        {panel === "main" && (
          <>
            {/* social links input item with label */}
            <div className="mainSliderForm__inputContainer">
              <label className="mainSliderForm__label">
                Campaign Page Title
              </label>
              <div className="mainSliderForm__input">
                {socialInputs.map((item, index) => (
                  <input
                    key={index}
                    type="text"
                    placeholder={item.placeholder}
                    value={links[item.key] || ""}
                    className="mb-3"
                    onChange={(e) =>
                      setLinks((prev) => ({
                        ...prev,
                        [item.key]: e.target.value,
                      }))
                    }
                  />
                ))}
              </div>
            </div>
          </>
        )}

        <div>
          <button
            onClick={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
            className="mainSliderForm__btn"
          >
            save
          </button>
        </div>
      </form>
    </div>
  );
};

export default CampaignPageTitleForm;
